import { useState } from 'react'
import Paragraph from '../Paragraph/Paragraph'
import styles from './ReadMoreField.module.scss'
import cx from 'classnames'

interface ReadMoreFieldProps {
  content?: {
    html: string
  }
}

const ReadMoreField = ({ content }: ReadMoreFieldProps) => {
  const [readMoreIsOpen, setReadMoreIsOpen] = useState(false)

  const toggleReadMore = () => {
    setReadMoreIsOpen(!readMoreIsOpen)
  }

  if (!content) {
    return null
  }

  return (
    <div className={styles['read-more-field-container']}>
      {readMoreIsOpen && (
        // @ts-ignore
        <Paragraph text={content} fontSize={'md'} />
      )}
      <button onClick={toggleReadMore} className={styles['read-or-hide']}>
        {readMoreIsOpen ? 'Read Less' : 'Read More'}
        <div className={cx([styles['caret'], styles[readMoreIsOpen ? '' : 'is-open']])} />
      </button>
    </div>
  )
}

export default ReadMoreField
